import React, { Component } from 'react';
import {
    DisplayWeight,
    DisplayTemp,
    DisplaySalinity,
    DisplayDepth,
    DisplayWeather,
    DisplayPartner,
    DisplayDiveTypes,
    DisplayNdash
} from '../components/Display';

export interface IDiveModeInformationProps {
    // tslint:disable-next-line:no-any
    dive: any;
}

interface IDiveModeInformationState {
    // tslint:disable-next-line:no-any
    dive: any;
}

export default class DiveModeInformation extends Component<
    IDiveModeInformationProps,
    IDiveModeInformationState
> {
    constructor(props: IDiveModeInformationProps) {
        super(props);
        this.state = {
            dive: props.dive.diveAndMixes.dive
        };
    }

    render() {
        var dive = this.state.dive;

        return (
            <div className="dive__infoTable">
                <div className="dive__infoTable__item">
                    <h3>More information:</h3>
                </div>

                <div className="dive__infoTable__item">
                    <div>
                        <span>Surface temp.:</span>
                        <span>
                            <DisplayTemp data={dive.surfaceTemp} />
                        </span>
                    </div>
                    <div>
                        <span>Salinity:</span>
                        <span>
                            <DisplaySalinity data={dive.salinity} />
                        </span>
                    </div>
                    <div>
                        <span>Serial:</span>
                        <span>
                            {dive.serial === null || dive.serial === '' ? (
                                <DisplayNdash />
                            ) : (
                                dive.serial
                            )}
                        </span>
                    </div>
                </div>

                <div className="dive__infoTable__item">
                    <div>
                        <span>Visibility:</span>
                        <span>
                            <DisplayDepth data={dive.visibility} />
                        </span>
                    </div>
                    <div>
                        <span>Weather:</span>
                        <span>
                            <DisplayWeather data={dive.weather} />
                        </span>
                    </div>
                    <div>
                        <span>Partner:</span>
                        <span>
                            <DisplayPartner data={dive.partner} />
                        </span>
                    </div>
                </div>

                <div className="dive__infoTable__item">
                    <div>
                        <span>Weight:</span>
                        <span>
                            <DisplayWeight data={dive.weight} />
                        </span>
                    </div>
                    <div>
                        <span>Dive type:</span>
                        <span>
                            <DisplayDiveTypes data={dive.diveType} />
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DiveModeInformation.tsx